import { type SiteResponse, updateSite } from '@lms/api-client/backend';
import { HexToHSL } from '@lms/ui/branding';

// Ports features/branding/actions.ts (`saveSettings`). The Next server action
// validated the primary colour, called the backend and `revalidatePath`'d the
// settings page. Here it is a plain async function: it validates and calls the
// backend site-update endpoint; the caller refreshes the brand via SWR
// `mutate(['site', slug])` in place of `revalidatePath`.
export type Changes = Partial<
  Pick<
    SiteResponse,
    | 'name'
    | 'groupAlias'
    | 'primaryColor'
    | 'secondaryColor'
    | 'logo'
    | 'poster'
    | 'hasGroups'
  >
>;

export async function saveSettings(
  changes: Changes,
  siteId: number,
): Promise<void> {
  if (changes.primaryColor) {
    // Just make sure it parses before we save and crash all rendering.
    HexToHSL(changes.primaryColor);
  }

  await updateSite(siteId, changes);
}
